import {
  TASK_TYPE_GENERALUPLOADTEXT,
} from 'src/services/constants';
import { buildLabel } from 'src/utilities/naming';

export const TASK_TYPE_LOE = 'LOE';
export const TASK_TYPE_CONSENT_SSN = 'SSN';
export const TASK_TYPE_TAX_TRANSCRIPT = 'TAX TRANSCRIPT';
export const TASK_TYPE_TAX_STATUS = 'Taxstatus';
export const TASK_TYPE_ESIGN = 'eSign';
export const TASK_TYPE_CONFIRMATION = 'Confirmation Input';
export const TASK_TYPE_TEXT_INPUT = 'General Text Input';
export const TASK_TYPE_GENERALUPLOADORTEXT = 'General Upload or Description';


export const TASK_TYPE_PAYMENTS_REQUESTS = 'PAYMENT REQUESTS';

export const LETTER_OF_EXPLANATION = 'Letter Of Explanation';
export const BORROWERS = 'borrowers';
export const BORROWERS_2 = 'id_front';
export const BORROWERS_3 = 'id_back';

export const BANK_STATEMENT = 'bankstatement';
export const MONTHLY_INCOME = 'monthly_income';
export const ANNUAL_INCOME = 'annual_income';
export const TAX_RETURNS = 'tax_returns';
export const PURCHASE_AGREEMENT = 'purchase_agreement';
export const K1_DOC = 'k_one';
export const CREDIT_REPORT = 'credit_report';
export const INVOICES = 'invoices';
export const GREENCARD = 'greencard';
export const SUMMARY_DEBT = 'summary_debt';
export const FROM_TEN_NINTY_NINE = 'ten_ninty_nine';
export const TEN_O_THREE_ARTIFACT = 'lendsmart_sh_action_ten_O_three';
export const VOIE_REPORT = buildLabel('artifact_voie_report');
export const VOA_REPORT = buildLabel('artifact_voa_report');
export const CASHFLOW_REPORT = buildLabel('artifact_cashflow_report');

export const AUTO_GENERATED_LOES = buildLabel('auto_generated_loes');
export const YEARS_IN_INDUSTRY = buildLabel('years_in_industry');
export const YEARS_WITH_EMPLOYER = buildLabel('years_with_employer');

export const DOCUMENT_RAILZ_BALANCE_SHEET_LABEL = buildLabel(
  'railz_balance_sheet'
);

export const DOCUMENT_BUSINESS_INCOME_STATEMENTS = buildLabel(
  'railz_business_income_statements'
);

export const DOCUMENT_CASH_FLOW_STATEMENT = buildLabel(
  'artifact_cashflow_report'
);

export const DOCUMENT_TAXRETURNS_INDIVIDUAL = buildLabel(
  'artifact_tax_returns_individual'
);

export const DOCUMENT_TAXRETURNS_CORPORATE = buildLabel(
  'artifact_tax_returns_corporate'
);

export const DOCUMENT_BANKSTATEMENT_PERSONAL = buildLabel(
  'artifact_bankstatement_personal'
);

export const DOCUMENT_BANKSTATEMENT_BUSINESS = buildLabel(
  'artifact_bankstatement_business'
);

export const BUSINESS_ENTITY_DOCUMENTS = buildLabel(
  'business_entity_documents'
);

export const VOM_SUBJECT = buildLabel('verification_of_mortgage_subject');

export const STRATTON_RCN_APPLICATION = buildLabel('stratton_rcn_application');

export const VOM_PRIMARY = buildLabel('verification_of_mortgage_primary');

export const VOM_OTHER_INVESTMENTS = buildLabel(
  'verification_of_mortgage_other_investments'
);

export const PAYOFF_STATEMENTS = buildLabel('payoff_statements');
export const DOCUMENT_FINANCIALS_LABEL = buildLabel('financials');
export const DOCUMENT_HOUSING_COUNSELOR_LABEL = buildLabel('housing_counselor');
//BC contract artifact
export const APPLICANT_CONTRACT = buildLabel('applicant_contract');

// Document pointer category
export const CONSENT_FOR_SSN_CATEGORY = 'SSN Disclosure';
export const CONSENT_FOR_TAX_TRANSCRIPT_CATEGORY = 'Tax Transcript';
export const PRE_APPROVAL_CATEGORY = 'Pre-qualification';

export const DOCUMENT_GREENCARD_LABEL = buildLabel(GREENCARD);
export const DOCUMENT_SUMMARY_DEBTS_LABEL = buildLabel(SUMMARY_DEBT);
export const DOCUMENT_BORROWERS_LABEL = buildLabel(BORROWERS);
export const DOCUMENT_BANK_STATEMENT_LABEL = buildLabel(BANK_STATEMENT);
export const DOCUMENT_MONTHLY_INCOME_LABEL = buildLabel(MONTHLY_INCOME);
export const DOCUMENT_ANNUAL_INCOME_LABEL = buildLabel(ANNUAL_INCOME);
export const DOCUMENT_TAX_RETURNS_LABEL = buildLabel(TAX_RETURNS);
export const DOCUMENT_REPRESENTS_PURCHASE_AGREEMENT_LABEL =
  buildLabel(PURCHASE_AGREEMENT);
export const DOCUMENT_REPRESENTS_K1_LABEL = buildLabel(K1_DOC);
export const DOCUMENT_CREDIT_REPORT_LABEL = buildLabel(CREDIT_REPORT);
export const DOCUMENT_VOIDED_CHECKS_LABEL = buildLabel('voided_checks');
export const DOCUMENT_REPREDENTS_HOME_INSPECTION_LABEL =
  buildLabel('home_appraiser');
export const DOCUMENT_REPRESENTS_CONTRACT_FORMS_LABEL = buildLabel(
  'executed_sales_contract'
);

export const DOCUMENT_PROFIT_AND_LOSS_LABEL = buildLabel('12_Month_P_and_L');
export const DOCUMENT_REPRESENT_APPLICATION_ARTIFACT =
  buildLabel('application');
export const DOCUMENT_BACKGROUND_CHECK_LABEL = buildLabel('background_check');
export const DOCUMENT_PAYOFF_LETTERS_LABEL = buildLabel('payoff_letters');
export const DOCUMENT_EXCEPTIONS_LABEL = buildLabel('exceptions');

// Document phase
export const DOCUMENT_PHASE_READY = 'Ready';
export const DOCUMENT_PHASE_SCRAPER_FAILED = 'Error';
export const DOCUMENT_PHASE_VALIDATION_FAILED = 'ValidationFailed';
export const DOCUMENT_PHASE_AUTHENTICITY_FAILED = 'AuthenticityFailed';
export const DOCUMENT_PHASE_PENDING = 'Pending';
export const DOCUMENT_PHASE_SCRAPPED = 'Scrapped';

// Document represents schema for SBAPPP

export const ARTICLES_OF_INCORPORATION = buildLabel(
  'articles_of_incorporation'
);
export const IRS_FORM_940 = buildLabel('irs_form_940');
export const IRS_FORM_941 = buildLabel('irs_form_941');
export const PAYROLL_SUMMARY_REPORT = buildLabel('payroll_summary_report');
export const CERTIFICATION_OF_EMPLOYEES = buildLabel(
  'certification_that_all_employees_live_in_the_US'
);
export const PROFIT_AND_LOSS = buildLabel('12_month_P_and_L');
export const MORTGAGE_OR_RENT_STATEMENT = buildLabel(
  'recent_mortgage_statement_rent'
);
export const RECENT_UTILITY_BILL = buildLabel('recent_utility_bills');
export const ARTIFACT_ADDITIONAL_DOCUMENTS = buildLabel(
  'additional_documents'
);
export const SPA_PPP_FORMS = buildLabel('sbappp_forms');
export const FORM_XML_SBAPPP = buildLabel('sbappp_xml');
export const SBA_PPP_W3 = buildLabel('w3');
export const SBA_PPP_OWNER_FORM = buildLabel('owner_form');
export const SBA_PPP_ORGNAIZATIONAL_DOCUMENTS = buildLabel(
  'organizational_documents'
);
export const DOCUMENT_REPRESENTS_INVOICE_ARTIFACT = buildLabel('invoices');
export const DOCUMENT_FUNDING_PACKAGE_LABEL = buildLabel('funding_package');
export const DOCUMENT_PERSONAL_FINANCIAL_STATEMENT_ARTIFACT = buildLabel('personal_financial_statement');
// Document for SBAPPP
export const DOCUMENT_REPRESENTS_ARTICLES_OF_INCORPORATION =
  'Articles of incorporation';
export const DOCUMENT_REPRESENTS_UNDER_WRITER_EXCEL = 'UW Excel sheet';
export const DOCUMENT_REPRESENTS_IRS_FORM_940 = 'IRS form 940';
export const DOCUMENT_REPRESENTS_IRS_FORM_941 = 'IRS form 941';
export const DOCUMENT_REPRESENTS_PAYROLL_SUMMARY_REPORT =
  'Payroll summary report';
export const DOCUMENT_REPRESENTS_CERTIFICATION_OF_EMPLOYEES =
  'Certification that all employees live in the US';
export const DOCUMENT_REPRESENTS_PROFIT_AND_LOSS = '12 Month P&L';

export const DOCUMENT_REPRESENTS_FREDDIE_MAC = 'Freddie Mac';

export const DOCUMENT_REPRESENTS_FM_FULLFEEDBACK = 'Freddie Mac Full FeedBack';
export const DOCUMENT_REPRESENTS_FM_HVE = 'Freddie Mac HVE';
export const DOCUMENT_REPRESENTS_FM_DOCUMENT_CHECKLIST =
  'Freddie Mac Document Checklist';
export const DOCUMENT_REPRESENTS_FM_MERGED_CREDIT = 'Freddie Mac Merged Credit';

export const DOCUMENT_REPRESENTS_MORTGAGE_OR_RENT_STATEMENT =
  'Recent mortgage statement/rent';
export const DOCUMENT_REPRESENTS_RECENT_UTILITY_BILL = 'Recent utility bills';
export const DOCUMENT_REPRESENTS_PAYROLL_PROCESSING_RECORDS =
  'Payroll Processing records (ADP, Quickbooks, Paychecks)';

export const DOCUMENT_REPRESENTS_W3 = 'W3';
export const DOCUMENT_REPRESENTS_OWNER_FORM = 'Beneficial owner form';
export const DOCUMENT_REPRESENT_ORGANISATIONAL_DOCUMENTS =
  'Organizational Documents';
export const DOCUMENT_REPRESENTS_ADDITIONAL = 'Other documents';
export const DOCUMENT_REPREDENTS_HOME_INSPECTION = 'Home inspection';
export const DOCUMENT_REPRESENTS_CONTRACT_FORMS = 'Contract Forms';
export const DOCUMENTS_REPRESENT_ESIGN_LO_FORMS = 'Additional esign documents';
export const DOCUMENT_REPREDENTS_FINANCIALS = 'Financials';

export const PDF = 'pdf';
export const DOCX = 'docx';
export const XLSM = 'xlsm';
export const DOC = 'doc';
export const PNG = 'png';
export const JPEG = 'jpeg';
export const JPG = 'jpg';
export const GIF = 'gif';
export const BMP = 'bmp';
export const XLS = 'xls';
export const XLSX = 'xlsx';
export const TXT = 'txt';
export const CSV = 'csv';
export const CSV1 = 'csv1';
export const PPT = 'ppt';
export const PPTX = 'pptx';
export const RTF = 'rtf';
export const MP4 = 'mp4';
export const HTML = 'html';

export const FALSE_BOOLEAN = false;
export const TRUE_BOOLEAN = true;

export const INCREASE = 'increase';
export const DECREASE = 'decrease';

// The supported document categories
export const DOCUMENT_REPRESENTS_MERCHANT_LOAN_FORMS = 'Application';

export const DOCUMENT_REPRESENTS_SUMMARY_DEBTS = 'Summary of any debts';

export const DOCUMENT_REPRESENTS_ID = 'ID';
export const DOCUMENT_REPRESENTS_ID_FRONT = 'ID front side';
export const DOCUMENT_REPRESENTS_ID_BACK = 'ID back side';
export const DOCUMENT_REPRESENTS_BANKSTATEMENT = 'Bank statement';
export const DOCUMENT_REPRESENTS_BUSINESS_INCOME_STATEMENTS =
  'Business income statements';
export const DOCUMENT_REPRESENTS_CASH_FLOW_STATEMENT = 'Cash flow statement';
export const DOCUMENT_REPRESENTS_BALANCE_SHEET = 'Balance Sheet';

export const DOCUMENT_REPRESENTS_BUSINESS_ENTITY = 'Business entity documents';
export const DOCUMENT_REPRESENTS_PAYOFF_STATEMENTS = 'Payoff statements';
export const DOCUMENT_REPRESENTS_VOM_PRIMARY =
  'Verification of mortgage primary';
export const DOCUMENT_REPRESENTS_VOM_SUBJECT =
  'Verification of mortgage subject';
export const DOCUMENT_REPRESENTS_VOM_OTHER_INVESTMENTS =
  'Verification of other mortgage statements';
export const DOCUMENT_REPRESENTS_STRATTON_RCN_APPLICATION = 'RCN Application';

export const DOCUMENT_REPRESENTS_DIGITAL_BANKSTATEMENT =
  'Digital bank statement';
export const DOCUMENT_REPRESENTS_BANKSTATEMENT_2ND_SET =
  '2nd set of Bank statement';
export const DOCUMENT_REPRESENTS_ASSET_BANK_STATEMENT = 'Asset Bank statement';
export const DOCUMENT_REPRESENTS_ANNUAL_INCOME_2ND_SET = '2nd W2';
export const DOCUMENT_REPRESENTS_TAX_RETURNS_2ND_SET =
  '2nd set of Tax return statement';
export const DOCUMENT_REPRESENTS_PAYSTUBS_2ND_SET = '2nd Pay stubs';
export const DOCUMENT_REPRESENTS_PAYSTUBS = 'Pay stubs';
export const DOCUMENT_REPRESENTS_SECONDARY_ID = 'Secondary Id';

export const DOCUMENT_REPRESENTS_W2 = 'W2';
export const DOCUMENT_REPRESENTS_TAXRETURNS = 'Tax return statement';
export const DOCUMENT_REPRESENTS_TAXRETURNS_INDIVIDUAL =
  'Tax returns individual';
export const DOCUMENT_REPRESENTS_TAXRETURNS_CORPORATE = 'Tax returns corporate';
export const DOCUMENT_REPRESENTS_BANKSTATEMENT_PERSONAL =
  'Bank statement personal';
export const DOCUMENT_REPRESENTS_BANKSTATEMENT_BUSINESS =
  'Bank statement business';
export const DOCUMENT_REPRESENTS_MORTGAGES = 'Mortgages';
export const DOCUMENT_REPRESENTS_PURCHASE_AGREEMENT = 'Purchase agreement';
export const DOCUMENT_REPRESENTS_PURCHASE_AGREEMENTS = 'Purchase Agreement';
export const DOCUMENT_REPRESENTS_K1 = 'K1';
export const DOCUMENT_REPRESENTS_TAXRETURNS_FINANCIALS =
  'Tax Returns/ Financials';
export const DOCUMENT_BACKGROUND_CHECK = 'Background Check';
export const DOCUMENT_PAYOFF_LETTERS = 'Payoff Letters';
export const DOCUMENT_EXCEPTIONS = 'Exceptions';
export const DOCUMENT_REPREDENTS_CREDIT_REPORT = 'Credit report';
export const DOCUMENT_REPRESENTS_1099 = '1099';
export const DOCUMENT_REPRESENTS_INVOICES = 'Invoices';
export const DOCUMENT_REPRESENTS_GREENCARD = 'Greencard';
export const DOCUMENT_REPRESENTS_NOTHING = 'Unknown';
export const DOCUMENT_SALES_HISTORY = 'Sales history';
export const DOCUMENT_TEN_O_THREE = 'Application';
export const TEN_O_THREE_FILE_NAME = '1003_Application';
export const DOCUMENT_REPRESENTS_SSE_FORM_4 = 'SSE-4';
export const DOCUMENT_REPRESENTS_VOIDED_CHEQUE = 'Voided check';
export const ANSWERED_BOTH_W2_1099 = 'Both W2 and 1099';
export const DOCUMENT_REPRESENTS_ACCOUNTING_BALANCE_SHEET = 'Balancesheet';
export const DOCUMENT_REPRESENTS_DNB_REPORT = 'DNB Report';
export const DOCUMENT_REPRESENTS_APPLICANT_CONTRACT =
  'Contract';
export const BC_APPLICANT_CONTRACT_DOCUMENT_NAME =
  'Signed Business Loan and Service Agreement';
export const DOCUMENT_REPRESENTS_FUNDING_PACKAGE = 'Funding Package';
export const DOCUMENT_REPRESENTS_HOUSING_COUNSELOR = 'Housing counselor';


export const TASK_TYPE_CONFIG = [
  {
    label: "Collect Text Details",
    value: TASK_TYPE_TEXT_INPUT,
    tooltip: "Great for collecting text input from users. eg: What is your mother’s maiden name?",

  },
  {
    label: "Collect Documents",
    value: TASK_TYPE_GENERALUPLOADTEXT,
    tooltip: "Great for collecting documents from users. eg: Please upload the recent bank statements? The description is optional here.",
  }
]
